 
    const elements = document.querySelectorAll('.fade-in');
    let isVisibleArray = [];
    let isCategoryHeaderVisible = false;

    function checkIfVisible() {
      elements.forEach((element, index) => {
        const elementTop = element.getBoundingClientRect().top;
        const elementBottom = element.getBoundingClientRect().bottom;

        const isVisibleNow = elementTop < window.innerHeight && elementBottom >= 0;

        if (isVisibleNow && !isVisibleArray[index]) {
          element.classList.add('fade-in-visible');
          isVisibleArray[index] = true;
        }
      }); 

      const categoryHeader = document.querySelector('.category-header');
      const categoryHeaderTop = categoryHeader.getBoundingClientRect().top;
      const categoryHeaderBottom = categoryHeader.getBoundingClientRect().bottom;

      const isCategoryHeaderVisibleNow = categoryHeaderTop < window.innerHeight && categoryHeaderBottom >= 0;

      if (isCategoryHeaderVisibleNow && !isCategoryHeaderVisible) {
        categoryHeader.classList.add('category-header-visible');
        isCategoryHeaderVisible = true;
      }
    }

    // Call the checkIfVisible function on scroll to trigger the animations
    window.addEventListener('scroll', checkIfVisible);

    // Call the checkIfVisible function on page load to check the initial visibility
    window.addEventListener('load', checkIfVisible);

    // Additional JavaScript for the top banner slide-in animation
    const ribbon = document.querySelector('.top-delivery-banner');
    const slides = document.querySelectorAll('.slide');
    let activeSlideIndex = 0;
    let firstSlideAnimated = false;

    setTimeout(function() {
      ribbon.classList.add('animate');
    }, 200);

    setTimeout(function() {
      ribbon.classList.add('in-view');
    }, 2000);

    setTimeout(function() {
      ribbon.classList.add('fade-in');
    }, 4000);

    setInterval(function() {
      slides[activeSlideIndex].classList.remove('active');
      activeSlideIndex = (activeSlideIndex + 1) % slides.length;
      slides[activeSlideIndex].classList.add('active');

      if (activeSlideIndex === 0 && !firstSlideAnimated) {
        slides[activeSlideIndex].classList.remove('slide-first');
        firstSlideAnimated = true;
      }
    }, 5000);